import { Injectable } from '@angular/core';

import { ClipboardService as NgxClipboardService } from 'ngx-clipboard';

import { FocusManagerService } from '@common/modules/accessibility/focus-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {
  constructor(private focusManager: FocusManagerService, private ngxClipboardService: NgxClipboardService) {}

  public copyFromContent(content: string, focusSelector?: string): void {
    this.ngxClipboardService.copyFromContent(content);

    // copyFromContent function change the focus.
    // So, set the focus back to copy button.
    if (focusSelector) {
      setTimeout(() => {
        this.focusManager.focusByQuery(focusSelector);
      }, 100);
    }
  }
}
